export const nonIndexableRoutePatterns = [
  '/bot',
  '/book-now/**',
  '/customer',
  '/customer/**',
  '/emails/**',
  '/gift/card/claim',
  '/gift/card/complete',
  '/gift/card/confirm',
  '/gift/card/customer',
  '/gift/card/preview',
  '/gift/pass/claim',
  '/gift/pass/complete',
  '/gift/pass/confirm',
  '/gift/pass/customer',
  '/pass/complete',
  '/pass/confirm',
  '/pass/customer',
  '/payment/**',
  '/preview',
  '/unsupported-browser',
  '/widget',
  '/widget/**',
]

export const nonIndexableRouteRules = Object.fromEntries(
  nonIndexableRoutePatterns.map(path => [path, { robots: false }])
)

export const seoRouteRules = {
  ...nonIndexableRouteRules,
  '/book-now': { robots: true },
}

const normalizePath = (path) => {
  if (!path || path === '/') {
    return '/'
  }

  return path.replace(/\/+$/, '')
}

export const routeMatchesPattern = (path, pattern) => {
  const normalizedPath = normalizePath(path)

  if (pattern.endsWith('/**')) {
    const prefix = pattern.slice(0, -3)
    return normalizedPath.startsWith(`${prefix}/`)
  }

  return normalizedPath === pattern
}

export const isRouteIndexable = path => !nonIndexableRoutePatterns.some(
  pattern => routeMatchesPattern(path, pattern)
)

export const buildPublicSitemapEntries = (info, giftablePasses = []) => {
  if (!info?.success || info.settings?.indexingEnabled === false) {
    return []
  }

  const links = [
    {
      loc: '/',
      changefreq: 'daily',
      priority: '1.0',
    }
  ]

  if (info.tabs?.book) {
    links.push({
      loc: '/book-now',
      changefreq: 'always',
      priority: '1.0',
    })
  }

  if (info.tabs?.timetable) {
    links.push({
      loc: '/timetable',
      changefreq: 'always',
      priority: '1.0',
    })
  }

  if (info.tabs?.lastMinute) {
    links.push({
      loc: '/last-minute',
      changefreq: 'always',
      priority: '1.0',
    })
  }

  if (info.tabs?.giftCard) {
    links.push({
      loc: '/gift',
      changefreq: 'daily',
      priority: '1.0',
    })

    links.push({
      loc: '/gift/card',
      changefreq: 'daily',
      priority: '1.0',
    })
  }

  if (info.tabs?.pass) {
    for (const pass of giftablePasses) {
      links.push({
        loc: `/gift/pass?id=${pass.id}`,
        changefreq: 'weekly',
      })
    }

    links.push({
      loc: '/pass',
      changefreq: 'daily',
    })
  }

  if (info.tabs?.gallery) {
    links.push({
      loc: '/gallery',
      changefreq: 'weekly',
      priority: '1.0',
    })
  }

  if (info.tabs?.review) {
    links.push({
      loc: '/reviews',
      changefreq: 'daily',
      priority: '1.0',
    })
  }

  for (const page of Object.values(info.customPages || {})) {
    if (page?.slug) {
      links.push({
        loc: `/page/${page.slug}`,
        changefreq: 'weekly',
      })
    }
  }

  return links
}
